import { RootState } from '../../store';

export const getActiveWorkspace = (state: RootState): any =>
  state?.workspace?.activeWorkspace;

export const getWorkspacesUnreadCount = (state: RootState): any[] =>
  state?.workspace?.workspacesUnreadCount;
